import {
  Box,
  Grid,
  GridItem,
  Skeleton,
  SkeletonText,
  useColorModeValue,
} from "@chakra-ui/react";
import React from "react";
import ChatBoxShimmer from "./ChatBoxShimmer";

const DocumentsShimmer = () => {
  // Define the light and dark shades for a subtle contrast
  const skeletonStartColor = useColorModeValue("gray.100", "gray.700");
  const skeletonEndColor = useColorModeValue("gray.300", "gray.800");

  return (
    <Grid
      templateColumns={{ base: "repeat(1, 1fr)", md: "65% 35%" }}
      gap={6}
      minH="90vh"
      alignItems="stretch"
      px={{ base: 4, md: 8 }}
      py={6}
    >
      {/* Main Content Section */}
      <GridItem w="100%" mx="auto">
        <Box
          shadow="lg"
          borderRadius="xl"
          p={6}
          h="full"
          maxH="65vh"
          overflow="hidden"
          backgroundColor={"white"}
        >
          <Skeleton
            height="2rem"
            width="12rem"
            borderRadius="md"
            startColor={skeletonStartColor}
            endColor={skeletonEndColor}
          />

          {/* Inner Flex for Content */}
          <Box display="flex" py={8} gap={8} flexWrap="wrap">
            {/* Left Section (Skeleton buttons/links) */}
            <Box flex="1" maxW={{ base: "100%", md: "33%" }}>
              {Array(5)
                .fill("")
                .map((_, index) => (
                  <Skeleton
                    key={"Document Shimmer " + index}
                    height="2.5rem"
                    mb={4}
                    borderRadius="md"
                    startColor={skeletonStartColor}
                    endColor={skeletonEndColor}
                  />
                ))}
            </Box>

            {/* Right Section (Content placeholders) */}
            <Box flex="2" maxW={{ base: "100%", md: "67%" }}>
              <Skeleton
                height="1.5rem"
                width="10rem"
                mb={4}
                borderRadius="md"
                startColor={skeletonStartColor}
                endColor={skeletonEndColor}
              />
              <Skeleton
                height="3rem"
                width="100%"
                mb={4}
                borderRadius="md"
                startColor={skeletonStartColor}
                endColor={skeletonEndColor}
              />
              <Skeleton
                height="11rem"
                width="100%"
                mb={4}
                borderRadius="md"
                startColor={skeletonStartColor}
                endColor={skeletonEndColor}
              />
              <SkeletonText
                mt={4}
                noOfLines={3}
                spacing={3}
                skeletonHeight={5}
                borderRadius="md"
                startColor={skeletonStartColor}
                endColor={skeletonEndColor}
              />
              <Box mt={7} display="flex" justifyContent="flex-end" gap={5}>
                <Skeleton
                  height="2rem"
                  width="8rem"
                  borderRadius="md"
                  startColor={skeletonStartColor}
                  endColor={skeletonEndColor}
                />
                <Skeleton
                  height="2rem"
                  width="8rem"
                  borderRadius="md"
                  startColor={skeletonStartColor}
                  endColor={skeletonEndColor}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </GridItem>

      {/* ChatBox Section */}
      <GridItem w="100%" px={6} backgroundColor={"white"}>
        <ChatBoxShimmer />
      </GridItem>
    </Grid>
  );
};

export default DocumentsShimmer;
